var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1612 16C5.27795 16 0.211118 9.99399 0 0H4.44972C4.59588 7.33533 7.87633 10.4424 10.4747 11.0831V0H14.6646V6.32633C17.2305 6.05405 19.9263 3.17117 20.8357 0H25.0256C24.6829 1.64466 23.9998 3.20189 23.019 4.57429C22.0382 5.94668 20.7808 7.10472 19.3254 7.97597C20.9499 8.77206 22.3848 9.89886 23.5353 11.282C24.6859 12.6651 25.5259 14.2732 26 16H21.3879C20.9623 14.5001 20.0973 13.1575 18.9013 12.1404C17.7053 11.1233 16.2315 10.4769 14.6646 10.2823V16H14.1612Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogo);
export default __webpack_public_path__ + "static/media/VkLogo.60957af135b69454ffd9e74d680f0ff5.svg";
export { ForwardRef as ReactComponent };